// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .box-catalog-link {
  display: inline-block;
  margin-left: 16px;
  padding-left: 16px;
  border-left: 1px solid #efefef;
}
.presize-root .box-catalog-link .rds-link {
  font-size: 14px;
  cursor: pointer;
}
/*# sourceMappingURL=BoxRestrictionsToggle.css.map */`, "",{"version":3,"sources":["webpack://./BoxRestrictionsToggle.less","webpack://./src/components/BoxRestrictions/BoxRestrictionsToggle/BoxRestrictionsToggle.less"],"names":[],"mappings":"AAAA;EAEE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;ACAF;ADLA;EAOI,eAAA;EACA,eAAA;ACCJ;AACA,oDAAoD","sourcesContent":[".presize-root { \n .box-catalog-link {\n  display: inline-block;\n  margin-left: 16px;\n  padding-left: 16px;\n  border-left: 1px solid #efefef;\n  .rds-link {\n    font-size: 14px;\n    cursor: pointer;\n  }\n}\n \n}",".presize-root .box-catalog-link {\n  display: inline-block;\n  margin-left: 16px;\n  padding-left: 16px;\n  border-left: 1px solid #efefef;\n}\n.presize-root .box-catalog-link .rds-link {\n  font-size: 14px;\n  cursor: pointer;\n}\n/*# sourceMappingURL=BoxRestrictionsToggle.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
